// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, ".account_fe82 {\n  margin: 0 -1.25rem;\n  padding: 0 1.25rem;\n}", "",{"version":3,"sources":["/home/runner/work/telemetry/telemetry/ts/packages/frontend/src/component/Sidebar/Account.scss","Account.scss"],"names":[],"mappings":"AAEA;EACI,kBAAA;EACA,kBAAA;ACDJ","file":"Account.scss","sourcesContent":["@import \"@formant/ui/style/common\";\n\n.account {\n    margin: 0 (-$space-20);\n    padding: 0 $space-20;\n}\n",".account {\n  margin: 0 -1.25rem;\n  padding: 0 1.25rem;\n}"]}]);
// Exports
exports.locals = {
	"account": "account_fe82"
};
module.exports = exports;
